<script>
  import { mapGetters } from 'vuex'

  export default {

    name: 'DateSelect',

    props: ['id', 'selDay', 'selMonth', 'selYear', 'classes' ],

    data: function () {
      return {
        day: this.selDay,
        month: this.selMonth,
        year: this.selYear,
        months: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
        days: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
      }
    },

    $_veeValidate: {
      value () {
        return this.fullDate;
      },

    },

    watch: {
      day: function () {
        this.fullDate;
        this.updateValue();
        this.$emit('setDay', this.day);
      },
      month: function () {
        this.fullDate;
        this.updateValue();
        this.$emit('setMonth', this.month);
      },
      year: function () {
        this.fullDate;
        this.updateValue();
        this.$emit('setYear', this.year);
      }
    },
    computed: {
      ...mapGetters(['getLabel']),
      fullDate: function () {
        return this.day + "/" + (this.months.indexOf(this.month) < 9 ? '0' + (this.months.indexOf(this.month) + 1) : this.months.indexOf(this.month) + 1) + "/" + this.year;
      },
      selectYear: function () {
        let currentYear = new Date().getFullYear();
        return Array.from({length: 120}, (k, e) => currentYear - e);
      },
    },
    methods: {
      updateValue() {
        this.$emit("input", this.fullDate);
      }
    }
  }

</script>

<template>
    <div class="datePicker row no-gutters">

        <v-select v-model="day" :options="days" data-vv-as=" " name="day"
                  :class="classes" :placeholder="getLabel('ospedali.form.date.day.placeholder')" class="col-3 col-md-4">
                <span slot="no-options">
                  {{getLabel('ospedali.form.empty.select')}}
                </span>
        </v-select>

        <v-select v-model="month" :options="months" name="month"
                  :class="classes" :placeholder="getLabel('ospedali.form.date.month.placeholder')" class="col-5 col-md-4">
                <span slot="no-options">
                  {{getLabel('ospedali.form.empty.select')}}
                </span>
        </v-select>

        <v-select v-model="year" :options="selectYear" data-vv-as=" " name="year"
                  :class="classes" :placeholder="getLabel('ospedali.form.date.year.placeholder')" class="col-4 col-md-4">
                <span slot="no-options">
                  {{getLabel('ospedali.form.empty.select')}}
                </span>
        </v-select>
    </div>
</template>